import { UseMutationOptions } from "@tanstack/react-query";
import { authApi } from "api/Auth/api";
import { useMutationApi } from "api/hooks.ts";
import { AxiosError } from "axios";
import { ApiErrorResponse } from "types/models";

import LoginRequest = App.Http.Requests.Auth.LoginRequest;
import GetUserResponse = App.Http.Responses.User.GetUserResponse;

export const useLoginMutation = (
    options: UseMutationOptions<GetUserResponse, AxiosError<ApiErrorResponse>, LoginRequest> = {},
    silentError = false
) => {
    return useMutationApi<GetUserResponse, LoginRequest>({
        mutationKey: ["login"],
        mutationFn: (request: LoginRequest) => authApi.login(request, silentError),
        ...options,
    });
};

export const useTenantLoginMutation = (
    tenantSlug: string,
    options: UseMutationOptions<GetUserResponse, AxiosError<ApiErrorResponse>, LoginRequest> = {},
    silentError = false
) => {
    return useMutationApi<GetUserResponse, LoginRequest>({
        mutationKey: ["tenant-login", tenantSlug],
        mutationFn: (request: LoginRequest) => authApi.loginToTenant(request, tenantSlug, silentError),
        ...options,
    });
};

export const useLogoutMutation = (options: UseMutationOptions<null, AxiosError<ApiErrorResponse>, void> = {}) => {
    return useMutationApi<null, void>({
        mutationKey: ["logout"],
        mutationFn: () => authApi.logout(),
        ...options,
    });
};
